import XLSX from "xlsx";
import moment from "moment";

export default class Excel {
  // readFile reads an excel file and turn it into a javascript array
  // with each element represent a row.
  // if it passed a string array of date fields it will parse them from excel format to a string
  static readFile(file: Blob, dateFields: string[] = []): Promise<object[]> {
    return new Promise((resolve, reject) => {
      let rows: object[] = [];
      if (!file) return rows;
      let reader = new FileReader();
      reader.onload = (event: ProgressEvent) => {
        if (event.target) {
          let workbook = XLSX.read(reader.result, { type: "binary" });
          const firstSheetName = workbook.SheetNames[0];
          // @ts-ignore
          rows = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[firstSheetName]
          );
          // parse excel dates
          for (const row of rows) {
            for (const field of dateFields) {
              // @ts-ignore
              row[field] = Excel.parseDateToString(row[field]);
            }
          }
          resolve(rows);
        }
      };
      reader.readAsBinaryString(file);
    });
  }

  // parseDate parses an excel date into a javascript date
  static parseDate(excelDate: number) {
    let jsDate = null;
    if (excelDate && typeof excelDate === "number" && excelDate > 0) {
      let epochZeroDate = new Date(0);
      let offset = epochZeroDate.getTimezoneOffset(); // tz offset in min
      // new Date(year, month[, date[, hours[, minutes[, seconds[, milliseconds]]]]]);
      jsDate = new Date(0, 0, excelDate - 1, 0, -offset, 0);
    }
    return jsDate;
  }

  // parseDate parses an excel date into a string date of format `YYYY-MM-DD`
  static parseDateToString(excelDate: number) {
    let date = null;
    if (excelDate && typeof excelDate === "number" && excelDate > 0) {
      let epochZeroDate = new Date(0);
      let offset = epochZeroDate.getTimezoneOffset(); // tz offset in min
      let jsDate = new Date(0, 0, excelDate - 1, 0, -offset, 0);
      date = moment(jsDate).format("YYYY-MM-DD");
    }
    return date;
  }
  workbook: XLSX.WorkBook = XLSX.utils.book_new();

  // addSheet adds a sheet to the excel book and populate it with data
  addSheet(
    sheetName: string,
    headers: string[],
    keys: string[],
    data: object[]
  ) {
    const flatData = [
      headers,
      ...data.map((row: any) => keys.map(key => row[key] || "")),
    ];

    const sheet = XLSX.utils.aoa_to_sheet(flatData);
    XLSX.utils.book_append_sheet(this.workbook, sheet, sheetName);
    return this;
  }

  // download downloads the excel file
  download(filename: string) {
    XLSX.writeFile(this.workbook, filename);
  }
}
